export const Divider = () => {
  return (
    <div
      className="eb_divider"
      style={{
        width: '98%',
        justifyContent: 'center',
      }}
    >
      <div style={{ flex: '1 1 1', border: '1px #DDDAE3 solid' }}></div>
    </div>
  );
};
